module.exports = fox._r("fonts/PTSans-Bold.ttf", __webpack_public_path__ + "_/_/_/root/fonts/1_9pW5N.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/PTSans-Bold.ttf
// module id = 198
// module chunks = 4